var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 50,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9085 15.383C38.8189 18.7718 45.2006 26.9319 45.2006 34.2831C45.2006 41.74 37.1341 47.7832 29.0004 47.7832C20.8668 47.7832 12.8003 41.74 12.8003 34.2831C12.8003 26.9319 19.1819 18.7718 24.0924 15.383L20.3604 6.48611C20.2101 6.22378 20.1166 5.93282 20.0859 5.63207C20.0551 5.33131 20.0879 5.02745 20.182 4.74015C20.2761 4.45285 20.4295 4.18851 20.6322 3.96422C20.8349 3.73992 21.0824 3.56068 21.3588 3.43809C26.319 1.8097 31.6699 1.8097 36.6301 3.43809C36.9075 3.55953 37.1562 3.73793 37.3602 3.96172C37.5641 4.18551 37.7188 4.44968 37.8141 4.73709C37.9093 5.02451 37.9431 5.32874 37.9132 5.63005C37.8833 5.93137 37.7904 6.22303 37.6405 6.48611L33.9085 15.383Z",
    stroke: "#00A3FA",
    strokeWidth: 3.24872,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.092 15.3828H33.9081",
    stroke: "#00A3FA",
    strokeWidth: 3.24872,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 45.983C3.80001 45.983 2 38.7829 2 33.7093C2.106 30.7363 2.94604 27.8357 4.44521 25.2662C5.94438 22.6967 8.05609 20.538 10.5921 18.9828L7.55844 14.6075C7.37148 14.3376 7.26194 14.0216 7.24167 13.6938C7.2214 13.3661 7.29117 13.039 7.44345 12.7481C7.59572 12.4571 7.82468 12.2134 8.10555 12.0432C8.38641 11.8731 8.70847 11.783 9.03686 11.7827H14.6001",
    stroke: "#8AD0F4",
    strokeWidth: 3.24872,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9901 37.8089C25.5097 38.4919 26.1863 39.0395 26.9626 39.4055C27.7388 39.7715 28.5918 39.945 29.4493 39.9113C32.183 39.9113 34.4006 38.2481 34.4006 36.1961C34.4006 34.1441 32.183 32.4857 29.4493 32.4857C26.7157 32.4857 24.5005 30.8224 24.5005 28.7704C24.5005 26.7184 26.7181 25.0576 29.4493 25.0576C30.3068 25.0228 31.1599 25.1956 31.9363 25.5612C32.7126 25.9268 33.3892 26.4745 33.9086 27.1576",
    stroke: "#00A3FA",
    strokeWidth: 3.24872,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4492 39.9111V42.3832",
    stroke: "#00A3FA",
    strokeWidth: 3.24872,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4492 22.583V25.0574",
    stroke: "#00A3FA",
    strokeWidth: 3.24872,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9999 45.983C54.2 45.983 56 38.7829 56 33.7093C55.894 30.7363 55.054 27.8357 53.5548 25.2662C52.0556 22.6967 49.9439 20.538 47.4079 18.9828L50.4416 14.6075C50.6285 14.3376 50.7381 14.0216 50.7583 13.6938C50.7786 13.3661 50.7088 13.039 50.5566 12.7481C50.4043 12.4571 50.1753 12.2134 49.8945 12.0432C49.6136 11.8731 49.2915 11.783 48.9631 11.7827H43.3999",
    stroke: "#8AD0F4",
    strokeWidth: 3.24872,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price-icon.d30593074e8ffd28a2c67cf33c3b1740.svg";
export { ForwardRef as ReactComponent };